<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M16.6339 9.35147C17.122 9.8201 17.122 10.5799 16.6339 11.0485L12.8839 14.6485C12.3957 15.1172 11.6043 15.1172 11.1161 14.6485L7.36612 11.0485C6.87796 10.5799 6.87796 9.8201 7.36612 9.35147C7.85427 8.88284 8.64573 8.88284 9.13388 9.35147L12 12.1029L14.8661 9.35147C15.3543 8.88284 16.1457 8.88284 16.6339 9.35147Z" fill="#737880"/>
  </svg>
</template>
